import { Box, Text, BoxProps, useMantineTheme } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { WizardSidebarSteps } from './WizardSidebarSteps';
import type { WizardActions, WizardStepsData } from './types';

export type WizardSidebarProps = BoxProps &
  Pick<WizardActions, 'goToStep'> & {
    title: string;
    steps: WizardStepsData;
    hideVirtualLastStep?: boolean;
    doneStepsIndex?: number[];
    availableStepsIndex?: number[];
    currentStepIndex?: number;
  };

/**
 * WizardSidebar component
 * @private
 */
export const WizardSidebar: React.FC<WizardSidebarProps> = ({
  title,
  steps,
  hideVirtualLastStep,
  goToStep,
  doneStepsIndex = [],
  currentStepIndex,
  availableStepsIndex = [],
  sx,
  ...boxProps
}) => {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  return (
    <Box
      bg={theme.other.background}
      px={16}
      py={24}
      sx={{
        minHeight: 300,
        boxShadow: 'inset -10px 0px 10px 0px rgba(30, 28, 73, 0.12)',
        ...sx,
      }}
      {...boxProps}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          rowGap: 24,
        }}
      >
        <Text fz="xl" fw={700}>
          {t(title)}
        </Text>
        <WizardSidebarSteps
          steps={steps}
          hideVirtualLastStep={hideVirtualLastStep}
          doneStepsIndex={doneStepsIndex}
          availableStepsIndex={availableStepsIndex}
          currentStepIndex={currentStepIndex}
          goToStep={goToStep}
        />
      </Box>
    </Box>
  );
};
